export const isAnonymousUser = (userEmail?: string | null) =>
  userEmail?.toLowerCase().endsWith("@anon.protea") ?? false;
